import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import DetailsContentWrapper from 'components/_modules/wrappers/DetailsContentWrapper/index.js';
import TextContent from 'components/TextContent';
import Preloader from 'components/Preloader/Preloader';
import InvestmentTable from 'components/_modules/policy/InvestmentTable';
import { DATA_CHARTS_GET_GRAPHICS_DATA } from 'api';
import Chart from 'components/Chart';
import styles from './styles.module.scss';

const InvestmentIncomeTab = ({ items, policyId }) => {
    const [initialization, setInitialization] = useState(false);
    const [loading, setLoading] = useState(true);
    const [graphicsData, setGraphicsData] = useState({});

    useEffect(() => {
        const fetchGraphAdditionalIncomeData = (index) => {
            DATA_CHARTS_GET_GRAPHICS_DATA(index, policyId).then((data) => {
                setGraphicsData(data);
            }).then(() => {
                setInitialization(true);
                setLoading(false);
            });
        };
        if (initialization === false) {
            fetchGraphAdditionalIncomeData(items.find((item) => item.type === 'additional_income_graph').index);
        } else {
            setLoading(false);
        }
    }, [initialization, items, policyId]);

    return (
        loading
            ? <DetailsContentWrapper>
                <div className={styles.PreloaderWrapper}>
                    <Preloader embedded/>
                </div>
            </DetailsContentWrapper>
            : <React.Fragment>
                {items.map((item, itemIndex) => (
                    <React.Fragment key={itemIndex}>
                        {item.type === 'content' && (
                            <DetailsContentWrapper title={item.title}>
                                {item.values.map((value, valueIndex) => (
                                    <TextContent key={valueIndex}
                                        dangerouslySetInnerHTML={{ __html: value.value }}/>
                                ))}
                            </DetailsContentWrapper>
                        )}
                        {item.type === 'additional_income_graph' && graphicsData.RESULT === 'OK' && (
                            <DetailsContentWrapper title={item.title}>
                                <Chart
                                    data={graphicsData}
                                    index={item.index}
                                />
                            </DetailsContentWrapper>
                        )}
                        {(item.type === 'coupon_income_table') && (
                            <DetailsContentWrapper
                                title={item.title}
                                isToggle={item.closed}
                            >
                                {item.rows.length >= 3 && item.rows[2] && <InvestmentTable rows={item.rows}/>}
                            </DetailsContentWrapper>
                        )}
                    </React.Fragment>
                ))}
            </React.Fragment>
    );
};

export default inject('store')(observer(InvestmentIncomeTab));
